// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1HnOD","paramInput":"JobSimulator_paramInput__23wgV","input":"JobSimulator_input__2NLUI"};